
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.015h-13.34a3.334 3.334 0 01-3.334-3.335V10.337a3.334 3.334 0 013.335-3.335h21.675a3.334 3.334 0 013.335 3.335V18.5m-21.676-4.828h15.007M14.67 20.34h6.67m-6.67 6.67h5.003m8.31 2.34a2.333 2.333 0 11-3.3 3.3 2.333 2.333 0 013.3-3.3m9.332-4.667a2.334 2.334 0 11-3.3 3.3 2.334 2.334 0 013.3-3.3m0 9.333a2.334 2.334 0 11-3.3 3.3 2.334 2.334 0 013.3-3.3M28.41 29.96l5.18-2.59m-5.18 4.671l5.18 2.59"}})])
          )
        }
      }
    